if (typeof jQuery !== 'undefined') {

  jQuery(document).ready(function($) {
    fetch('/cart.js', {
      method: 'GET',
      headers: {'Content-Type': 'application/json'}
    })
    .then(response => response.json())
    .then(data => {
      CartJS.init(data, {
        "dataAPI": true,
        "moneyFormat": window.moneyFormat,
        "moneyWithCurrencyFormat": window.moneyWithCurrencyFormat
      });
    }).catch((error) => {
      console.error('Error:', error);
    });
    
    let openCart = true;

    jQuery(document).on('cart.ready', function(event, cart) {
      window.dispatchEvent( new CustomEvent('cart-count-update', {'detail': {cartCount: cart.item_count }}) );
      window.dispatchEvent( new CustomEvent('cart-initiated', {'detail': {cart: cart }}) );

      try {
  
        const cartAttributes = CartJS.getAttributes()
        let utmMapper = {
          'utm_source': '_custom_utm_source',
          'utm_campaign': '_custom_utm_campaign',
          'utm_content': '_custom_utm_content',
          'utm_medium': '_custom_utm_medium',
          'sk': '_custom_sk',
          'tbclid': '_custom_tbclid',
          'gclid': '_custom_gclid',
          'publisher': '_custom_publisher',
          'campaign_name': '_custom_campaign_name',
        }
        let firstUtmMapper = {
          'utm_source': '_first_utm_source',
          'utm_campaign': '_first_utm_campaign',
          'utm_content': '_first_utm_content',
          'utm_medium': '_first_utm_medium',
          'sk': '_first_sk',
          'tbclid': '_first_tbclid',
          'gclid': '_first_gclid',
          'publisher': '_first_publisher',
          'campaign_name': '_first_campaign_name',
        }
  
        const urlParams = new URLSearchParams(window.location.search);
        const keys = Object.keys(utmMapper);
  
        for (const key of keys) {
          const value = urlParams.get(key);
          if (window.localStorage && value) {
            localStorage.setItem(utmMapper[key], value);
          }
        }
        if (document.referrer) {
          localStorage.setItem("_custom_referrer", document.referrer);
        }
  
        const firstkeys = Object.keys(firstUtmMapper);
        for (const key of firstkeys) {
          const value = urlParams.get(key);
          if (window.localStorage && value) {
            if (!localStorage.getItem(firstUtmMapper[key])) {
              localStorage.setItem(firstUtmMapper[key], value);
            }
          }
        }
  
  
        if (document.referrer && !localStorage.getItem('_first_referrer')) {
          localStorage.setItem("_first_referrer", document.referrer);
        }
  
        let cartAttributesChanged = false
        if (window.localStorage) {
  
          for (const key of firstkeys) {
            const utmKey = firstUtmMapper[key];
            if (utmKey && localStorage.getItem(utmKey) && cartAttributes[utmKey] != localStorage.getItem(utmKey)) {
              cartAttributesChanged = true;
              cartAttributes[utmKey] = localStorage.getItem(utmKey);
            }
          }
  
          for (const key of keys) {
            const utmKey = utmMapper[key];
            if (utmKey && localStorage.getItem(utmKey) && cartAttributes[utmKey] != localStorage.getItem(utmKey)) {
              cartAttributesChanged = true;
              cartAttributes[utmKey] = localStorage.getItem(utmKey);
            }
          }
        }
  
        if (cartAttributesChanged) {
          openCart = false
          CartJS.setAttributes(cartAttributes)
        }
      } catch (e) {
      }
    });

    jQuery(document).on('cart.requestStarted', function(event, cart) {
      if (openCart) {
        window.dispatchEvent( new CustomEvent('open-cart', {'detail': {open: true}}) ); 
        window.dispatchEvent( new CustomEvent('cart-loading', {'detail': {loading: true}}))
      } else {
        openCart = true
      }
    });

    jQuery(document).on('cart.requestComplete', function(event, cart) {
      if (openCart)  {
        window.dispatchEvent( new CustomEvent('cart-request-complete', {'detail': {cart: cart, loading: false}}))
        window.dispatchEvent( new CustomEvent('cart-update', {'detail': {cart: cart, loading: false}}))
        window.dispatchEvent( new CustomEvent('cart-count-update', {'detail': {cartCount: cart.item_count }}) );
      } else {
        openCart = true
      }
      

      const c = document.querySelector(".cart-link__bubble-num");
      if (c) { c.innerHTML = cart.item_count }

      if (cart.item_count == 1 && cart.total_price == 0) {
        CartJS.updateItem(1, 0);
        return;
      } 

      let pricyItems = 0;
      for (const item of cart.items) {
        if (item.price > 0) {
          pricyItems++;
        }
      }
      if (pricyItems == 0 && cart.item_count > 0) {
        CartJS.clear();
        return;
      }

      let n = 1;
      for (const item of cart.items) {
        if (item.price == 0 && item.quantity > 1) {
          CartJS.updateItem(n, 1)
          return;
        }
        n++;
      }
    });
    

    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('open_cart')) {
        window.dispatchEvent( new CustomEvent('open-cart', {'detail': {open: true}}) );
      } 
    } catch (e) {}
  });

} else {
  console.error('jQuery not loaded');
}